import { render, staticRenderFns } from "./DingTalkSyncTaskCenter.vue?vue&type=template&id=04dc9f4b&scoped=true"
import script from "./DingTalkSyncTaskCenter.vue?vue&type=script&lang=js"
export * from "./DingTalkSyncTaskCenter.vue?vue&type=script&lang=js"
import style0 from "./DingTalkSyncTaskCenter.vue?vue&type=style&index=0&id=04dc9f4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04dc9f4b",
  null
  
)

export default component.exports